import React, { useEffect, useRef, useState } from "react";
import Card from "react-bootstrap/Card";
import myImg from "../../Assets/meetjoan.webp";
import { useTranslation } from "react-i18next";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";

function AboutCardHome() {
   const { t } = useTranslation();
   const containerRef = useRef(null);
   const [countersStarted, setCountersStarted] = useState(false);
   const location = useLocation();
   const isEnglish = location.pathname.startsWith("/en");
   const basePath = isEnglish ? "/en" : "";

   useEffect(() => {
      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               if (entry.isIntersecting) {
                  const profilePic = entry.target.querySelector(".profile-pic");
                  const picShadow = entry.target.querySelector(".pic-shadow");
                  const aboutTextContainer = entry.target.querySelector(
                     ".about-text-container",
                  );
                  const carouselContainer =
                     entry.target.querySelector(".history-carousel");
                  const experienceContainer = entry.target.querySelector(
                     ".experience-container",
                  );

                  if (profilePic) profilePic.classList.add("visible");
                  if (picShadow) picShadow.classList.add("visible");
                  if (aboutTextContainer)
                     aboutTextContainer.classList.add("visible");
                  if (carouselContainer)
                     carouselContainer.classList.add("visible");
                  if (experienceContainer) setCountersStarted(true);
                  
                  observer.unobserve(entry.target);
               }
            });
         },
         { threshold: 0.05, rootMargin: "0px 0px -50px 0px" },
      );

      if (containerRef.current) {
         observer.observe(containerRef.current);
      }

      return () => {
         if (containerRef.current) {
            observer.unobserve(containerRef.current);
         }
      };
   }, []);

   return (
      <Card className="quote-card-view" id="aboutme">
         <Card.Body>
            <div
               className="about-card-container"
               id="stretch"
               ref={containerRef} // Asignación limpia del ref
            >
               <div className="about-text-container">
                  <blockquote className="blockquote mb-0">
                     <h2 id="about-title">{t("my_history")}</h2>
                     <h3 className="heading-short-title">
                        <span className="purple">{t("name")}</span>
                        <span> {t("dronepilot")}</span>
                     </h3>
                     <p className="meet-description">{t("meet_desc_1")}</p>
                     <p className="meet-description">{t("meet_desc_2")}</p>
                     <p className="meet-description">{t("meet_desc_3")}</p>
                  </blockquote>
                  <Link
                     to={`${basePath}/sobre-mi`}
                     className="learn-more-link"
                     title="Sobre mí"
                  >
                     {t("learn_more")} <AiOutlineArrowRight />
                  </Link>
               </div>
               <div className="profile-home-pic-container">
                  <img
                     src={myImg}
                     className="profile-pic-home"
                     alt="avatar"
                     title="Avatar"
                     loading="lazy"
                  />
               </div>
            </div>
         </Card.Body>
      </Card>
   );
}

export default AboutCardHome;
